import React from "react";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import AppointmentCalender from "../../Common/AppointmentCalender";
import PatientProgress from "../../Common/PatientProgress";
import CountUp from "react-countup";
import FeatherIcon from "feather-icons-react";

const Dashboard = ()=>{
    return(
        <React.Fragment>
            <Row className="mt-5">
                <Col>
                    <Row>
                        <Col>
                            <PatientProgress/>
                        </Col>
                    </Row>
                </Col>
                <Col>
                    <Card className="card-animate shadow-sm">
                        <CardBody>
                            <AppointmentCalender/>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default Dashboard;